export default __webpack_public_path__ + "static/media/brand-1.76575117.jpg";